import React, { Component } from "react"
import { connect } from "react-redux"
import { formatPercent, formatCurrency } from "../../utils"
import Card from "../../components/Card"
import Hidable from "../../components/Hidable"
import Spacer from "../../components/Spacer"
import Button from "react-toolbox/lib/button/Button"
import SimpleTable from "../../components/SimpleTable"
import LabeledValue from "../../components/LabeledValue"
import * as strings from "../../strings"
import styles from "./styles.css"
import { toastr } from "react-redux-toastr"
import _ from "lodash"
import { withActions } from "../../utils"
import AutomaticExpenseRuleDialog from "./AutomaticExpenseRuleDialog"
import StateTransitionDialog from "./StateTransitionDialog"

const AUTOMATIC_EXPENSE_RULE_COLUMNS = {
  startDate: {
    title: strings.generalStrings.startDate,
  },
  endDate: {
    title: strings.generalStrings.endDate,
  },
  value: {
    title: strings.generalStrings.value,
  },
  calculationType: {
    title: strings.generalStrings.type,
  },
}

const STATE_TRANSITION_COLUMNS = {
  fromState: {
    title: strings.expenses.fromState,
  },
  toState: {
    title: strings.expenses.toState,
  },
}



class ExpenseType extends Component {
  props: {
    match: any,
    expenseType: any,
    actions: any,
  }

  state = {
    automaticExpenseDialogVisible: false,
    stateTransitionDialogVisible: false,
  }

  closeAutomaticExpenseRuleDialog = () => this.setState( { automaticExpenseDialogVisible: false } )
  closeStateTransitionDialog = () => this.setState( { stateTransitionDialogVisible: false } )

  createStateTransition = stateTransition => {
    this.props.actions.addExpenseTypeStateTransition( {
      idExpenseType: this.props.expenseType.id,
      ...stateTransition,
    } )
      .then( () => toastr.success( strings.expenses.stateTranstionAdded ) )
      .then( () => this.closeStateTransitionDialog() )
      .catch( () => toastr.error( strings.expenses.errorAddingStateTransition ) )
  }

  removeAutomaticExpenseRule = aer => {
    this.props.actions.removeAutomaticExpenseRule( aer.id )
      .then( () => toastr.success( strings.expenses.automaticExpenseRuleRemoved ) )
      .catch( () => toastr.error( strings.expenses.errorRemovingAutomaticExpenseRule ) )
  }

  removeStateTransition = stateTransition => {
    this.props.actions.removeExpenseTypeStateTransition( {
      idExpenseType: this.props.expenseType.id,
      ...stateTransition,
    } )
      .then( () => toastr.success( strings.expenses.stateTranstionRemoved ) )
      .catch( () => toastr.error( strings.expenses.errorRemovingStateTransition ) )
  }

  createAutomaticExpenseRule = automaticExpenseRule => {
    this.props.actions.addAutomaticExpenseRule( {
      idExpenseType: this.props.expenseType.id,
      ...automaticExpenseRule,
    } )
      .then( () => toastr.success( strings.expenses.automaticExpenseRuleAdded ) )
      .then( () => this.closeAutomaticExpenseRuleDialog() )
      .catch( () => toastr.error( strings.expenses.errorAddingAutomaticExpenseRule ) )
  }

  renderAutomaticExpenseRules () {
    const { expenseType } = this.props
    if ( !expenseType.automaticExpensesEnabled ) {
      return null
    }

    const formatValue = aer => {
      if ( !aer.value ) {
        return "--"
      }

      return aer.calculationType === "Fixed"
        ? formatCurrency( aer.value )
        : formatPercent( aer.value )
    }

    const automaticExpenseRules = _.chain( expenseType )
      .get( "automaticExpenseRules", [] )
      .map( aer => ( {
        ...aer,
        calculationType: strings.AutomaticExpenseRuleCalculationTypeTranslation[ aer.calculationType ],
        value: formatValue( aer ),
        _actions: [
          { label: "Apagar", icon: "delete", onClick: () => this.removeAutomaticExpenseRule( aer ) },
        ],
      } ) )
      .orderBy( [ "startDate" ], [ "asc" ] )
      .value()


    return (
      <Hidable expanded title={strings.expenses.automaticExpenseRules}>
        <SimpleTable
          columns={AUTOMATIC_EXPENSE_RULE_COLUMNS}
          data={automaticExpenseRules}
        />
        <div className={styles.toolbar}>
          <Button
            icon="add"
            onClick={() => this.setState( {
              automaticExpenseDialogVisible: true,
            } )}
            label={strings.expenses.addAutomaticExpenseRule}
            raised
            primary
          />
        </div>
      </Hidable>
    )
  }

  renderStateTransitions () {
    const { expenseType } = this.props
    if ( !expenseType.automaticExpensesEnabled ) {
      return null
    }

    const stateTransitions = _.chain( expenseType )
      .get( "stateTransitions", [] )
      .map( stateTransition => ( {
        fromState: stateTransition.fromState || "Qualquer",
        toState: stateTransition.toState || "Qualquer",
        _actions: [
          { label: "Apagar", icon: "delete", onClick: () => this.removeStateTransition( stateTransition ) },
        ],
      } ) )
      .orderBy( [ "fromState" ], [ "asc" ] )
      .value()


    return (
      <Hidable expanded title={strings.expenses.expenseTypeStateTransitions}>
        <SimpleTable
          columns={STATE_TRANSITION_COLUMNS}
          data={stateTransitions}
        />
        <div className={styles.toolbar}>
          <Button
            icon="add"
            onClick={() => this.setState( {
              stateTransitionDialogVisible: true,
            } )}
            label={strings.expenses.addStateTransition}
            raised
            primary
          />
        </div>
      </Hidable>
    )
  }


  renderDetails () {
    const { expenseType } = this.props
    const billingPhase = strings.BillingPhaseTranslation[ expenseType.billingPhase ]
    const debtPhase = expenseType.debtPhase
      .map( phase => strings.DebtPhaseTranslation[ phase ] )
      .sort()
      .join( ", " )

    return (
      <Card decor className={styles.expenseTypeDetails}>
        <div className={styles.detailsTitle}>{expenseType.name}</div>
        <Spacer size={2}/>
        <div className={styles.row}>
          <LabeledValue label={strings.generalStrings.billingPhase}>{billingPhase}</LabeledValue>
          <Spacer size={4}/>
          <LabeledValue label={strings.processes.phase}>{debtPhase}</LabeledValue>
        </div>
      </Card>
    )
  }

  render () {
    const { expenseType } = this.props
    if ( !expenseType ) {
      return null
    }

    return (
      <div>
        {this.renderDetails()}
        {this.renderAutomaticExpenseRules()}
        {this.renderStateTransitions()}
        <AutomaticExpenseRuleDialog
          onSubmit={this.createAutomaticExpenseRule}
          onCancel={this.closeAutomaticExpenseRuleDialog}
          visible={this.state.automaticExpenseDialogVisible}
        />
        <StateTransitionDialog
          onSubmit={this.createStateTransition}
          onCancel={this.closeStateTransitionDialog}
          visible={this.state.stateTransitionDialogVisible}
          debtPhases={expenseType.debtPhase}
        />
      </div>
    )
  }
}

export default connect( ( store, props ) => ( {
  expenseType: _.chain( store )
    .get( "expenses.expenseTypes", [] )
    .find( { id: _.parseInt( props.match.params.id ) } )
    .value(),
} ) )( withActions ( ExpenseType ) )



// WEBPACK FOOTER //
// ./src/views/ManageExpenseTypes/ExpenseType.jsx